import { useMemo } from 'react';
import { useLocation, useSearchParams } from 'react-router-dom';

import { useNavigateSearch } from './useNavigateSearch';

const useModalRouter = () => {
	const { pathname } = useLocation();
	const navigateSearch = useNavigateSearch();
	const [searchParams] = useSearchParams();

	const isModal = useMemo(() => !!searchParams.get('modal'), [searchParams]);

	const showModal = (modalName, data) => {
		const params = {};

		searchParams.forEach((value, key) => {
			if (
				key !== 'modal' &&
				key !== 'modalID' &&
				key !== 'id' &&
				key !== 'ids' &&
				key !== 'mode' &&
				key !== 'minimized'
			) {
				params[key] = value;
			}
		});

		const ids = Array.isArray(data?.ids) && data.ids.length > 0 && data.ids.join(',');

		navigateSearch(pathname, {
			modal: modalName,
			modalID: Date.now(),
			...data,
			...(ids && { ids }),
			...params
		});
	};

	const closeModal = () => {
		const params = {};

		searchParams.forEach((value, key) => {
			if (
				key !== 'modal' &&
				key !== 'modalID' &&
				key !== 'id' &&
				key !== 'ids' &&
				key !== 'mode' &&
				key !== 'wizardStep' &&
				key !== 'minimized'
			) {
				params[key] = value;
			}
		});

		navigateSearch(pathname, {
			...params
		});
	};

	return { showModal, closeModal, isModal };
};

export default useModalRouter;
